import { render, staticRenderFns } from "./EBikes.vue?vue&type=template&id=62071bce&scoped=true"
import script from "./EBikes.vue?vue&type=script&lang=js"
export * from "./EBikes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62071bce",
  null
  
)

export default component.exports